import React, { useState, useCallback } from 'react';
import { AutorCreate, AutorUpdate } from '../../types';
import { api } from '../../api/client';

interface Props {
  initialData?: AutorCreate;
  onSubmit: () => void;
  onCancel: () => void;
  isEdit?: boolean;
  id?: number;
}

export default function AutorForm({ initialData, onSubmit, onCancel, isEdit = false, id }: Props) {
  const [data, setData] = useState<AutorCreate>(initialData || {
    nombre_autor: '',
    url_imagen: '',
  });

  const [imagen, setImagen] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append('nombre_autor', data.nombre_autor);
      if (imagen) formData.append('imagen', imagen);
      console.log(formData);
      if (isEdit && id) {
        await api.autores.update(id, formData);
      } else {
        await api.autores.create(formData);
      }
      onSubmit();
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error al guardar el autor';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [data, imagen, isEdit, id, onSubmit]);

  return (
    <form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow mb-4">
      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded" role="alert">
          <strong>Error:</strong> {error}
        </div>
      )}
      <div className="space-y-4">
        <input
          className="border p-2 w-full"
          placeholder="Nombre del autor *"
          value={data.nombre_autor}
          onChange={(e) => setData({ ...data, nombre_autor: e.target.value })}
          required
        />
        <div className="col-span-1 md:col-span-2">
          <label className="block mb-1 font-medium">Imagen</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImagen(e.target.files?.[0] || null)}
            className="w-full"
            disabled={loading}
          />
          {!imagen && data.url_imagen && (
            <img
              src={data.url_imagen}
              alt="Vista previa"
              className="mt-2 max-h-40 border rounded"
            />
          )}
        </div>
      </div>
      <div className="mt-4 flex space-x-2">
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
          {isEdit ? 'Actualizar' : 'Crear'}
        </button>
        <button type="button" onClick={onCancel} className="bg-gray-500 text-white px-4 py-2 rounded">
          Cancelar
        </button>
      </div>
    </form>
  );
}